import { isEnglish } from '@/lib/l18n/function';
import { newDate } from '@/utils/date';
import { formatInTimeZone } from 'date-fns-tz';

export { formatCurrency, formatDateAboutJa, formatDateCommon } from '@monorepo/common';

/**
 * 日時フォーマッター（多言語対応）
 * @param value
 * @param t 翻訳関数
 * @returns
 */
export const formatDateAboutI18n = (
  value: string | Date,
  t: (key: string, options?: Record<string, string | number>) => string,
) => {
  if (!value) return '';

  const targetDate = typeof value === 'string' ? newDate(value) : value;
  const year = targetDate.getFullYear();
  const month = targetDate.getMonth() + 1;
  const date = targetDate.getDate();

  // 旬を判定
  let period: 'early' | 'mid' | 'late';
  if (date < 11) {
    period = 'early';
  } else if (date < 21) {
    period = 'mid';
  } else {
    period = 'late';
  }

  const monthName = t(`months.${month}`);
  const periodText = t(`periods.${period}`);

  return t('deliveryEstimate', { year, month: monthName, period: periodText });
};

/**
 * 日時フォーマッター（多言語対応）
 * @param value
 * @param lang 言語
 * @returns
 */
export const formatDateCommonI18n = (value: string | Date, lang: string | undefined) => {
  if (!value) return '';

  const targetDate = typeof value === 'string' ? newDate(value) : value;

  if (isEnglish(lang)) {
    // 英語: "October 4, 2025, 12:00 PM (JST)"
    return formatInTimeZone(targetDate, 'Asia/Tokyo', "MMMM d, yyyy, h:mm a '(JST)'");
  }

  // 日本語: 既存のformatDateCommonと同じ形式
  return formatInTimeZone(targetDate, 'Asia/Tokyo', 'yyyy年MM月dd日 HH:mm');
};
